import { render, staticRenderFns } from "./groupQR.vue?vue&type=template&id=311c5c00&scoped=true"
import script from "./groupQR.vue?vue&type=script&lang=js"
export * from "./groupQR.vue?vue&type=script&lang=js"
import style0 from "./groupQR.vue?vue&type=style&index=0&id=311c5c00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c5c00",
  null
  
)

export default component.exports